<script setup lang="ts">
import AppNavbar from '~/components/AppNavbar.vue'
import AppFooter from '~/components/AppFooter.vue'
import { onBeforeMount } from 'vue'
import { useLenisStore } from '~/stores/lenisStore'

onBeforeMount(() => {
  const lenisStore = useLenisStore()
  lenisStore.initLenis()
})
</script>

<template>
  <div>
    <AppNavbar />
    <main>
      <slot />
    </main>
    <AppFooter />
  </div>
</template>
